import { CardInformationRow } from '@ingenico/react-ui/card-information-row';
import { InformationCardContainer } from '@ingenico/react-ui/information-card-container';
import { InformationCardTitle } from '@ingenico/react-ui/information-card-title';
import { InformationRowContainer } from '@ingenico/react-ui/information-row-container';

import classNames from 'classnames';
import type { ReactElement } from 'react';

import { toString } from 'lodash-es';
import type { HardwareDetailsDto } from '../../model/callLogs.model';
import type { UseDeviceCallLogPageOutput } from '../../pages/device-call-log-page/useDeviceCallLogPage.vm';
import styles from './HardwareDetailsInformation.module.scss';

export interface HardwareDetailsInformationProps extends Pick<UseDeviceCallLogPageOutput, 't'> {
  readonly hardwareDetails: HardwareDetailsDto;
}

export function HardwareDetailsInformation({ hardwareDetails, t }: HardwareDetailsInformationProps): ReactElement {
  return (
    <InformationCardContainer>
      <InformationCardTitle title={toString(t('cardTitle.hardwareDetails'))} />
      <div className={classNames(styles.bodyContainer)}>
        <div className={classNames(styles.sideContainer)}>
          <InformationRowContainer>
            <CardInformationRow
              label={toString(t('label.hardwareDetails.deviceModel'))}
              value={hardwareDetails.deviceModel}
            />
            <CardInformationRow
              isAllowCopyClipboard
              label={toString(t('label.hardwareDetails.serialNumber'))}
              value={hardwareDetails.serialNumber}
            />
            <CardInformationRow
              label={toString(t('label.hardwareDetails.battteryLevel'))}
              value={hardwareDetails.battteryLevel}
            />
            <CardInformationRow
              label={toString(t('label.hardwareDetails.connectivity'))}
              value={t(`values.connectivity.${hardwareDetails.connectivity}`, hardwareDetails.connectivity)}
            />
          </InformationRowContainer>
        </div>
        <div className={classNames(styles.sideContainer)}>
          <InformationRowContainer>
            <CardInformationRow
              label={toString(t('label.hardwareDetails.manufacturer'))}
              value={toString(
                t(`values.manufacturer.${hardwareDetails.manufacturer}`, {
                  defaultValue: hardwareDetails.manufacturer,
                }),
              )}
            />
            <CardInformationRow
              isAllowCopyClipboard
              label={toString(t('label.hardwareDetails.hardwareReference'))}
              value={hardwareDetails.hardwareReference}
            />
            <CardInformationRow
              label={toString(t('label.hardwareDetails.batteryStatus'))}
              value={toString(hardwareDetails.batteryStatus)}
            />
          </InformationRowContainer>
        </div>
      </div>
    </InformationCardContainer>
  );
}
